function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_3132_28872)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 2,
  width: 40,
  height: 40,
  rx: 20,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 28L26 22L20 16",
  stroke: "#333333",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 3.5,
  y: 2.5,
  width: 39,
  height: 39,
  rx: 19.5,
  stroke: "#D5D8DF"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_3132_28872",
  x: 0,
  y: 0,
  width: 46,
  height: 46,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3132_28872"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3132_28872",
  result: "shape"
})));
const SvgArrowButton = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-button.1a0e5db4.svg";
export { ForwardRef as ReactComponent };